/*
 * @Author: yang_yang 1663724228@qq.com
 * @Date: 2023-02-22 15:54:46
 * @LastEditors: yang_yang 1663724228@qq.com
 * @LastEditTime: 2023-02-22 16:02:38
 * @FilePath: \jyh5\src\assets\i18n\config\zh.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { month } from "../zh/commApp/monthlyHealthReport"

export {
    month
}


// WEBPACK FOOTER //
// ./src/assets/i18n/config/zh.js